export default "__VITE_ASSET__vBP8WyKN__"